<template>
  <div>
    <h2>{{ title }}</h2>
    <apexchart
      type="line"
      :options="chartOptions"
      :series="series"
      height="350"
    ></apexchart>
  </div>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'TotalScansLineChart',
  props: {
    title: {
      type: String,
      required: true,
    },
    series: {
      type: Array,
      required: true,
      default: () => [],
    },
    categories: {
      type: Array,
      required: true,
      default: () => [],
    }
  },
  setup(props) {
    const chartOptions = computed(() => ({
      chart: {
        height: 350,
        type: 'line',
        zoom: {
          enabled: false
        },
        theme: 'dark',
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'straight'
      },
      grid: {
        row: {
          colors: ['#404040', 'transparent'],
          opacity: 0.5
        },
      },
      xaxis: {
        categories: props.categories,
        labels: {
          style: {
            colors: '#fff'
          }
        }
      },
              yaxis: {
                labels: {
                  style: {
                    colors: '#fff'
                  },
                  formatter: function (value) {
                    if (typeof value === 'number') {
                      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                    return value;
                  }
                }
              },
              tooltip: {
                theme: 'dark',
                y: {
                  formatter: function (value) {
                    if (typeof value === 'number') {
                      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }
                    return value;
                  }
                }
              },      legend: {
        labels: {
          colors: '#fff'
        }
      }
    }));

    return {
      chartOptions,
    };
  }
};
</script>

<style>
.apexcharts-menu {
  background-color: #333 !important;
  border-color: #555 !important;
}
.apexcharts-menu-item {
  color: #fff !important;
}
.apexcharts-menu-item:hover {
  background-color: #555 !important;
}
</style>